export const MALE = 'male';
export const FEMALE = 'female';
export const UNKNOWN = 'unknown';
